var map = {
	"./birds.png": 30,
	"./date.png": 31,
	"./deer.png": 32,
	"./egg.png": 33,
	"./eyes.png": 34,
	"./floating.png": 7,
	"./flowers.png": 35,
	"./heart.png": 36,
	"./highheel.png": 37,
	"./intro.jpg": 8,
	"./kiwi.png": 38,
	"./kiwi2.png": 39,
	"./kiwiandkorv.png": 40,
	"./landscape.png": 9,
	"./moose.png": 41,
	"./ms.jpg": 42,
	"./red.png": 43,
	"./uncomp/birds.png": 44,
	"./uncomp/date.png": 45,
	"./uncomp/egg.png": 46,
	"./uncomp/eyes.png": 47,
	"./uncomp/floating.png": 48,
	"./uncomp/flowers.png": 49,
	"./uncomp/heart.png": 50,
	"./uncomp/highheel.png": 51,
	"./uncomp/intro.jpg": 52,
	"./uncomp/kiwi.png": 53,
	"./uncomp/kiwi2.png": 54,
	"./uncomp/kiwiandkorv.png": 55,
	"./uncomp/landscape.png": 56,
	"./uncomp/moose.png": 57,
	"./uncomp/ms.jpg": 58,
	"./uncomp/red.png": 59
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;


//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/.*$
// module id = 29
// module chunks = 0